import type { Level } from "../puzzles/types";
import { t } from "../strings";
import { dayTotal, maxOfResult, namedAt, type RoundResult } from "./share";

/**
 * The words on the share image (DECISIONS 2026-10-03 "A spoiler-free share card"). Built only from the score,
 * the level and the puzzle number — never from the day's content — so the friend who receives it learns
 * nothing about today's puzzle. A unit test checks every day against its answers and places.
 */
export interface CardText {
  puzzle: string;
  score: string;
  rows: { label: string; points: string }[];
  named: string;
  cta: string;
  url: string;
}

export function cardText(o: { number: number; level: Level; vault: boolean; results: readonly RoundResult[]; dayMax: number }): CardText {
  const labels = [t.card.pin, t.card.next, t.card.who];
  return {
    puzzle: t.card.puzzle(o.number, t.levels[o.level].label, o.vault),
    score: t.card.score(dayTotal([...o.results]), o.dayMax),
    rows: labels.map((label, i) => {
      const r = o.results[i];
      return { label, points: r ? t.card.score(r.score, maxOfResult(r)) : "–" };
    }),
    named: t.card.named(namedAt([...o.results])),
    cta: t.card.cta,
    url: "whosteps.com",
  };
}
